import {AlertService} from '../../shared/services/alert.service';
import { Component, OnInit } from '@angular/core';
import { AssessmentService } from 'app/shared/services/assessment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Assessment } from 'app/shared/models/assessment';
import { Question } from 'app/shared/models/question';
import { QuestionType } from 'app/shared/models/question-type';

@Component({
  selector: 'app-assessment-view',
  templateUrl: './assessment-view.component.html',
  styleUrls: ['./assessment-view.component.css']
})
export class AssessmentViewComponent implements OnInit {
  public assessment:Assessment;
  public hasLoadedAssessment:boolean;
  
  constructor(
    private route:ActivatedRoute
    ,private router:Router
    ,private assessmentService:AssessmentService
    ,private alertService:AlertService
  ) { 
    this.assessment = new Assessment();
  }

  ngOnInit() {
    let uid = this.route.snapshot.params['uid'];
    let version = this.route.snapshot.queryParams['version'];
    this.assessmentService.uid = uid;
    let assessmentPromise;
    if (version) {
      assessmentPromise = this.assessmentService.getAssessmentVersion(uid, version);
    } else {
      assessmentPromise = this.assessmentService.getAssessment(uid);
    }
    assessmentPromise.then((assessment) => {
				if (assessment) {
					this.assessment = assessment;
					this.hasLoadedAssessment = true;
				}
				else {
					// TODO: stephen handle 404 errors
					//this._$state.go("404");
          this.router.navigate(["page-not-found"]);
				}
			}).catch((error) => {
				this.hasLoadedAssessment = true;
				// TODO: stephen can't all of this just go in the catch block below?
				console.error(error);
				this.alertService.error("Failed to retrieve assessment data from server");
				this.assessment = new Assessment();
				this.assessment.uid = this.assessmentService.uid;
			});
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/assessment-view/assessment-view.component.ts